import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ParlamentarianCreateEditProvider } from './context/parlamentarian-create-edit-context';
import { ParlamentarianCreateEditComponent } from './parlamentarian-create-edit-component';

export function ParlamentarianCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <ParlamentarianCreateEditProvider>
                <ParlamentarianCreateEditComponent />
            </ParlamentarianCreateEditProvider>
        </BaseLayoutFactory>
    );
}
